import { isNil } from 'ramda';

import { IKnmRequirementViolation } from 'APIPackage/KnmModule/interfaces/IKnmRequirementViolation';
import { IKnmErknmFormViolation } from 'KnmErknmPackage/ErknmViolationsModule/interfaces/IKnmErknmFormViolation';
import { convertFormDateValueToKnmDataDate } from 'KnmPackage/MainModule/common/convertFormDateValueToKnmDataDate';
import { IViolationMaterialTypeSelectOption } from 'CorePackage/CatalogsModule/interfaces/IViolationMaterialTypeSelectOption';
import { convertViolationFixesFormValuesToKnmData } from 'KnmErknmPackage/MainModule/common/convertViolationFixesFormValuesToKnmData';
import { IKnmString } from 'APIPackage/KnmModule/interfaces/IKnmString';

import { handleReactQuillDeltaValue } from '../../../functions/handleReactQuillDeltaValue';

export function convertViolationsFormValuesToKnmData(
  formViolations: IKnmErknmFormViolation[],
  isDraft: boolean | undefined,
): IKnmRequirementViolation[] {
  return formViolations.map(violation => {
    return {
      isNew: isDraft ? violation.isNew : null,
      guid: violation.id || null,
      status: violation.status || null,
      description: violation.title || null,
      descriptionReactQuillEditor: handleReactQuillDeltaValue(
        violation.descriptionReactQuillEditor || violation.title || null,
      ),
      notRemoval: typeof violation.isUnfixable?.value === 'boolean' ? violation.isUnfixable.value : null,
      correctedInEvent: typeof violation.isFixedOnPlace?.value === 'boolean' ? violation.isFixedOnPlace.value : null,
      explanation: violation.explanation,
      explanationReactQuillEditor: handleReactQuillDeltaValue(
        violation.explanationReactQuillEditor || violation.explanation || null,
      ),
      corrected: typeof violation.isFixed?.value === 'boolean' ? violation.isFixed.value : null,
      appealed: typeof violation.isAppealed?.value === 'boolean' ? violation.isAppealed.value : null,
      isViolationResolved:
        typeof violation.isViolationResolved?.value === 'boolean' ? violation.isViolationResolved.value : null,
      isViolationResolvedNote: violation.isViolationResolvedNote || null,
      dateResolvedByAgreement: convertFormDateValueToKnmDataDate(violation.dateResolvedByAgreement),
      previousDateResolvedByAgreement: convertFormDateValueToKnmDataDate(violation.previousDateResolvedByAgreement),

      remediationPlan: {
        guid: violation.fixPlanId || null,
        plannedEliminationDates: violation.fixPlanDates?.length
          ? violation.fixPlanDates
              .map<IKnmString>(dateItem => ({
                isNew: isDraft ? dateItem.isNew : null,
                guid: dateItem.guid,
                dateCreate: dateItem.dateCreate,
                value: convertFormDateValueToKnmDataDate(dateItem.value),
              }))
              .filter(item => !isNil(item.value))
          : null,
        plannedMethod: violation.fixPlanMethods?.length
          ? (violation.fixPlanMethods
              .map(methodItem => methodItem.value)
              .filter(item => !isNil(item)) as IViolationMaterialTypeSelectOption[])
          : null,
        descriptions: violation.fixPlanExplanations?.length
          ? violation.fixPlanExplanations
              .map<IKnmString>(explanationItem => ({
                isNew: isDraft ? explanationItem.isNew : null,
                guid: explanationItem.guid,
                dateCreate: explanationItem.dateCreate,
                value: explanationItem.value,
                valueReactQuillEditor: handleReactQuillDeltaValue(
                  explanationItem.valueReactQuillEditor || explanationItem.value,
                ),
              }))
              .filter(item => !isNil(item.value))
          : null,
      },

      actualEliminationDate: convertFormDateValueToKnmDataDate(violation.fixFactDate),
      actualMethod: violation.fixFactMethod || null,
      eliminationViolations: violation.fixes?.length
        ? convertViolationFixesFormValuesToKnmData(violation.fixes, isDraft)
        : null,
      updated: violation.updated,
      updatedBy: violation.updatedBy,

      includeInSubject: typeof violation.includeInSubject === 'boolean' ? violation.includeInSubject : null,
      prescriptionLink: violation.prescriptionLink || null,
      number: violation.number || null,
      repeatCorrected: typeof violation.repeatCorrected?.value === 'boolean' ? violation.repeatCorrected.value : null,
      repeatCorrectedInEvent:
        typeof violation.repeatCorrectedInEvent?.value === 'boolean' ? violation.repeatCorrectedInEvent.value : null,
      repeatExplanation: violation.repeatExplanation,
      targetLink: violation.targetLink || null,
      targetErpId: violation.targetErpId || null,
      resolvedIn: violation.resolvedIn || null,
    };
  });
}
